import { AdditionalContext } from '../rate-quote/types';

export const getFromAdditionalContext = (additionalContext: AdditionalContext, property: string) =>
  (additionalContext.find((info) => info.name === property) || { value: '' }).value;
